import React, {useEffect} from 'react';
import loaderImg from '../../../assets/images/buttonLoader.svg'

function ButtonLoader(props) {

    return (<img style={{width: "20px"}} className="ms-2 d-none" src={loaderImg}/>);
}

export default ButtonLoader;